import { PaginationResponse } from "models/pagination-response";
import { IUnidadeSaudePagedRequest } from "models/request/unidade-saude-paged-request";
import { IUnidadeSaudePagedResponse } from "models/response/unidade-saude-paged-response";

export type UnidadesSaudeState = {
    unidadesSaude: PaginationResponse<IUnidadeSaudePagedResponse>;
    unidadeSaudePagedRequest: IUnidadeSaudePagedRequest;
    loading: boolean;
    error: string | null;
};

export enum ACTION_TYPES {
    setUnidadesSaude = 'setUnidadesSaude',
    setUnidadeSaudePagedRequest = 'setUnidadeSaudePagedRequest',
    setLoading = 'setLoading',
    setError = 'setError',
}

export const UnidadesSaudeReducer = (state: UnidadesSaudeState, action: any): UnidadesSaudeState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setUnidadeSaudePagedRequest:
            return { ...state, unidadeSaudePagedRequest: payload };
        case ACTION_TYPES.setUnidadesSaude:
            return { ...state, unidadesSaude: payload };
        case ACTION_TYPES.setLoading:
            return { ...state, loading: payload };
        case ACTION_TYPES.setError:
            return { ...state, error: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}
